import $ from 'jquery';
import MicroModal from 'micromodal';

import { FireComponent } from '@base';

export class ImageGallery extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $modal: this.$component.find('[data-gallery-modal]'),
    };
  }

  _modal() {
    if (this.elements.$modal.length) {
      MicroModal.init({
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: false,
        awaitCloseAnimation: false,
        onShow: (modal, trigger, event) => {
          const container = modal.querySelector('.bux-card-carousel__container');
          const rightArrow = modal.querySelector('[data-right-arrow]');
          if (container && rightArrow) {
            container.scrollTo(0, 0); // reset position
            const clickedImage = event.target;
            const modalImage = modal.querySelector(`[data-modal-image-id="${clickedImage.parentNode.getAttribute('data-image-id')}"]`);
            const offsetPosition = modalImage.getBoundingClientRect();
            container.scrollTo(offsetPosition.left, 0);
            rightArrow.style.display = 'flex';
          }
        },
      });
    }
  }

  init() {
    if (this.componentExists) {
      this._modal();
    }
  }
}
